/*
 * Fall Sale 2026 - Fly bundle PARENT pages only (the ten ...-fall-sale-bundle products, for example
 * /products/mina-pitcher-complete-fall-sale-bundle). Loaded by snippets/price-list.liquid only when
 * that page's price block resolved a Fall card, so no other page downloads it.
 *
 * DISPLAY ONLY. Charges, cart payloads, buttons and Fly's own sale figures are never touched, and no
 * attribute on a Fly node is ever written (Fly's morphDOM strips attributes it did not render). The
 * figures come from the JSON in #FallBundlePageData, which snippets/price-list.liquid renders
 * server-side with the Fall picker's own math (snippets/fall-sale-option-price.liquid).
 *
 * 1. FLY'S WIDGET. Fly strikes each line through at the variant's standing compare-at price when an
 *    offer has "show compare-at price" on (all ten Fall offers do), so a line on a standing sale shows
 *    that figure (MINA 3-Pack 77.97 instead of its regular 69.99), the "Total price" was-price is the
 *    compare-at sum, and the "% Off" pill is computed against it (27% on MINA Complete instead of the
 *    card's 25%). This rewrites ONLY these texts:
 *      - each line's  .gfbFrequentBoughtWidgetProductPriceOriginal         -> regular unit price x qty
 *      - the total's  .gfbFrequentBoughtWidgetPriceContainerPriceOriginal  -> full (sum of regular prices)
 *      - the pill     .gfbFrequentBoughtWidgetPriceContainerTotalSaving    -> its "NN%" -> the card's pct
 *
 * 2. THE THEME'S PRICE ELEMENTS: every element price-list.liquid marked
 *    data-fall-bundle-price="<offer id>:sale" or ":was" (the price block and the sticky add-to-cart bar).
 *    - Rounding. Liquid rounds the card's sale price once, on the total, half up. Fly adds up its
 *      per-line floats, so when the total ends in exactly half a cent the two differ by 1 cent (INTL
 *      Glass and Shower Complete: 502.70 x 0.75 = 377.025, Liquid 377,03, Fly 377,02). As the Fall
 *      picker's _reconcilePrice does, the page then shows Fly's total, so the price block and the
 *      widget agree. Only a gap of at most 1 cent is taken (the picker allows 5); a wider one fails
 *      safe (point 3).
 *    - Fly's native-price sync. "updateNativePriceSection" is ON for all ten Fall offers, and Fly
 *      would write its own figures (its compare-at sum as the was-price, no screen-reader label)
 *      into the elements carrying data-fly-bundles-native-*-price. Fly build 697 writes nothing
 *      only because it skips a block the theme has already marked. If a later build does write,
 *      this puts the card's figures back and says so (data-native="restored").
 *    These elements are written only in a pass where the widget agrees with the card (point 3), and
 *    only if, when this script started, every one of them showed exactly the server's figures.
 *
 * 3. FAIL-SAFE. Nothing is written unless the widget agrees with the server figures on every point
 *    that can be checked: the offer id, the exact set of line handles, each line's quantity, each
 *    line's DISCOUNTED price (Fly's own figure, within 1 cent of regular x qty x (100 - pct) / 100),
 *    the total sale (within 1 cent of the card's sale price) and the money format (same symbol,
 *    suffix and decimal separator as the server strings). Anything else - an unknown DOM, another
 *    offer, a different colour price, a quantity the shopper changed, a changed Fly config, an
 *    unexpected currency format - leaves every figure exactly as Fly and the theme drew it.
 *
 * 4. OBSERVERS, BOUNDED. Fly inserts the widget after DOMContentLoaded and later patches it in place
 *    (colour / option / quantity change), which puts its compare-at figures back. Two observers:
 *    - the wrapper of each matching widget and each marked price element, for text and child changes;
 *    - document.body for ADDED ELEMENTS only (no text changes): one selector check per added element,
 *      to catch Fly inserting or re-inserting the widget and the theme re-rendering the price block.
 *    If no widget for this offer has appeared SEEK_MS after the window load event, both observers
 *    are disconnected and the page is left alone. A pass runs in a microtask (before the next
 *    paint) and writes a text only when it differs, so the observers settle after one extra pass;
 *    no Fly observer watches these nodes, so the writes cannot start a loop. A second copy of this
 *    script on the same page exits at once.
 *
 * Status for QA and probes, on #FallBundlePageData (whichever copy is in the document now):
 *   data-status       waiting | applied | unchanged:<reason>   (the widget; "offer <ids>" = Fly shows
 *                     another offer, "no widget" = none appeared in time)
 *   data-native       ok | restored | overwritten:<roles> | unknown:<reason>   (the price elements)
 *   data-sale-source  card (the card's own sale price) | fly (Fly's total, 1 cent apart)
 */
(function () {
  'use strict';

  if (window.__fallSaleBundlePage) return;
  var DATA_ID = 'FallBundlePageData';
  var firstDataEl = document.getElementById(DATA_ID);
  if (!firstDataEl) return;
  window.__fallSaleBundlePage = true;

  var TAG = '[fall-sale-bundle-page]';
  var WRAPPER = '.gfbFrequentBoughtWrapper';
  var OFFER = '.gfbFrequentBoughtWidgetOfferContainer';
  var LINE = '.gfbFrequentBoughtWidgetProductContainer';
  var LINE_SALE = '.gfbFrequentBoughtWidgetProductPriceDiscounted';
  var LINE_WAS = '.gfbFrequentBoughtWidgetProductPriceOriginal';
  var TOTAL = '.gfbFrequentBoughtWidgetPriceContainer';
  var TOTAL_SALE = '.gfbFrequentBoughtWidgetPriceContainerPriceDiscounted';
  var TOTAL_WAS = '.gfbFrequentBoughtWidgetPriceContainerPriceOriginal';
  var PILL = '.gfbFrequentBoughtWidgetPriceContainerTotalSaving';
  var PCT_RE = /\d+%/; // the pattern Fly itself uses for its pill text
  var SEEK_MS = 30000;

  // ------------------------------------------------------------------ status
  var state = { status: 'waiting', native: null, sale: null };
  // The theme can replace the price block (and this element with it) on a re-render; always report
  // on the element that is in the document now.
  function statusEl() {
    return document.getElementById(DATA_ID) || firstDataEl;
  }
  function setAttr(el, name, value) {
    if (value !== null && el.getAttribute(name) !== value) el.setAttribute(name, value);
  }
  function report() {
    var el = statusEl();
    setAttr(el, 'data-status', state.status);
    setAttr(el, 'data-native', state.native);
    setAttr(el, 'data-sale-source', state.sale);
  }
  var warned = {};
  function fail(why) {
    state.status = 'unchanged:' + why;
    if (!warned[why]) {
      warned[why] = true;
      if (window.console && console.warn) console.warn(TAG + ' left Fly prices unchanged: ' + why);
    }
    return null;
  }

  // ------------------------------------------------------------------ money
  // Parse a money string drawn with exactly two decimals ("$1,234.56", "1.234,56 EUR", "GBP 87.18"):
  // its integer cents and its shape (text before / after the number, decimal separator).
  function money(text) {
    var t = String(text == null ? '' : text).replace(/\s+/g, ' ').trim();
    var m = t.match(/^(\D*?) ?(\d(?:[\d.,' ]*\d)?) ?(\D*)$/);
    if (!m) return null;
    var num = m[2];
    if (num.length < 4) return null;
    var dec = num.charAt(num.length - 3);
    if ((dec !== '.' && dec !== ',') || !/^\d\d$/.test(num.slice(-2))) return null;
    return { pre: m[1].trim(), suf: m[3].trim(), dec: dec, cents: parseInt(num.replace(/\D/g, ''), 10) };
  }
  function sameShape(a, b) {
    return !!a && !!b && a.pre === b.pre && a.suf === b.suf && a.dec === b.dec;
  }
  function isInt(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n;
  }
  // The same money text with another amount, in the sample's own separators. Null when the sample
  // cannot show how this format groups thousands (a 3-digit sample and a 4-digit amount).
  function reformat(sample, cents) {
    var s = String(sample);
    var m = s.match(/\d(?:[\d.,'\s]*\d)?/);
    if (!m || !isInt(cents) || cents < 0) return null;
    var num = m[0];
    var dec = num.charAt(num.length - 3);
    if ((dec !== '.' && dec !== ',') || !/^\d\d$/.test(num.slice(-2))) return null;
    var intPart = num.slice(0, -3);
    var sep = intPart.match(/\D+/);
    var whole = String(Math.floor(cents / 100));
    if (sep) whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, function () { return sep[0]; });
    else if (whole.length > 3 && intPart.length <= 3) return null;
    var frac = String(cents % 100);
    if (frac.length < 2) frac = '0' + frac;
    return s.slice(0, m.index) + whole + dec + frac + s.slice(m.index + num.length);
  }

  // ------------------------------------------------------------------ server data
  var data;
  try {
    data = JSON.parse(firstDataEl.textContent);
  } catch (e) {
    fail('data is not JSON');
    report();
    return;
  }

  // Validate the server data on its own before looking at the page: a broken render never writes.
  var ref = null; // shape of the plain money texts (what Fly draws)
  var nativeRef = null; // shape of the price block's own texts (money, or money_with_currency)
  var byHandle = {};
  (function validate() {
    var d = data;
    if (!d || d.v !== 1 || typeof d.offerId !== 'string' || !/^[A-Za-z]+-\d+$/.test(d.offerId)) return fail('data: version / offer id');
    if (!isInt(d.saleCents) || !isInt(d.fullCents) || !isInt(d.discountPct)) return fail('data: figures');
    if (!(d.saleCents > 0 && d.saleCents < d.fullCents)) return fail('data: sale >= full');
    if (Math.round(((d.fullCents - d.saleCents) * 100) / d.fullCents) !== d.discountPct) return fail('data: pct');
    var s = money(d.saleText);
    var f = money(d.fullText);
    if (!s || !f || s.cents !== d.saleCents || f.cents !== d.fullCents || !sameShape(s, f)) return fail('data: texts');
    var ps = money(d.priceSaleText);
    var pf = money(d.priceFullText);
    if (!ps || !pf || ps.cents !== d.saleCents || pf.cents !== d.fullCents || !sameShape(ps, pf)) return fail('data: price texts');
    if (typeof d.saleLabel !== 'string' || !d.saleLabel || typeof d.wasLabel !== 'string' || !d.wasLabel) return fail('data: labels');
    if (!Array.isArray(d.lines) || !d.lines.length) return fail('data: lines');
    var sum = 0;
    for (var i = 0; i < d.lines.length; i++) {
      var l = d.lines[i];
      if (!l || typeof l.handle !== 'string' || !l.handle || byHandle.hasOwnProperty(l.handle)) return fail('data: line handle');
      if (!isInt(l.qty) || l.qty < 1 || !isInt(l.unitCents) || l.unitCents < 1) return fail('data: line ' + l.handle);
      var w = money(l.wasText);
      if (!w || w.cents !== l.unitCents * l.qty || !sameShape(w, s)) return fail('data: line text ' + l.handle);
      byHandle[l.handle] = l;
      sum += l.unitCents * l.qty;
    }
    if (sum !== d.fullCents) return fail('data: lines do not add up to full');
    ref = s;
    nativeRef = ps;
    return true;
  })();
  if (!ref) {
    report();
    return;
  }

  // ------------------------------------------------------------------ the theme's price elements
  var NATIVE_SALE = '[data-fall-bundle-price="' + data.offerId + ':sale"]';
  var NATIVE_WAS = '[data-fall-bundle-price="' + data.offerId + ':was"]';
  var NATIVE = NATIVE_SALE + ', ' + NATIVE_WAS;
  // An added element that is, or contains, one of these is worth a pass.
  var ADDED = WRAPPER + ', ' + OFFER + ', ' + NATIVE + ', #' + DATA_ID;

  function isLabel(n) {
    return n.nodeType === 1 && n.classList.contains('sr-only');
  }
  // What a price element shows: whether its screen-reader label is there, and its amount.
  function readNative(el) {
    var label = false;
    var text = '';
    for (var n = el.firstChild; n; n = n.nextSibling) {
      if (isLabel(n)) label = true;
      else if (n.nodeType === 1 || n.nodeType === 3) text += n.textContent;
    }
    return { label: label, m: money(text) };
  }
  function shows(r, cents) {
    return r.label && !!r.m && sameShape(r.m, nativeRef) && r.m.cents === cents;
  }
  // Write label + amount, keeping the theme's own nodes when its shape is intact:
  // [whitespace] <span class="sr-only">label</span>amount.
  function writeNative(el, label, text) {
    var sr = null;
    for (var n = el.firstChild; n; n = n.nextSibling) {
      if (isLabel(n)) {
        sr = n;
        break;
      }
    }
    var amount = sr && sr.nextSibling;
    var before = sr && sr.previousSibling;
    var intact =
      !!amount && amount.nodeType === 3 && !amount.nextSibling &&
      (!before || (before.nodeType === 3 && !/\S/.test(before.nodeValue) && !before.previousSibling));
    if (intact) {
      if (amount.nodeValue !== text) amount.nodeValue = text;
      return;
    }
    if (!sr) {
      sr = document.createElement('span');
      sr.className = 'sr-only';
      sr.textContent = label;
    }
    while (el.firstChild) el.removeChild(el.firstChild);
    el.appendChild(sr);
    el.appendChild(document.createTextNode(text));
  }
  // The price block's sale text for an amount: the server's own, or the same format with Fly's total.
  function priceText(cents) {
    if (cents === data.saleCents) return data.priceSaleText;
    var t = reformat(data.priceSaleText, cents);
    var m = t && money(t);
    return m && m.cents === cents && sameShape(m, nativeRef) ? t : null;
  }

  // Only manage elements that still show exactly what the server rendered when this script starts;
  // anything else means some other script got there first, and they are left to it.
  var nativeOn = false;
  (function () {
    var els = document.querySelectorAll(NATIVE);
    if (!els.length) {
      state.native = 'unknown:no price elements';
      return;
    }
    for (var i = 0; i < els.length; i++) {
      var role = els[i].matches(NATIVE_SALE) ? 'sale' : 'was';
      if (!shows(readNative(els[i]), role === 'sale' ? data.saleCents : data.fullCents)) {
        state.native = 'unknown:' + role + ' not as rendered';
        return;
      }
    }
    nativeOn = true;
    state.native = 'ok';
    state.sale = 'card';
  })();

  // ------------------------------------------------------------------ the widget
  function lineQty(lineEl) {
    var input = lineEl.querySelector('input.gfbFrequentBoughtQuanityBox'); // Fly's own spelling
    if (input && /^\d+$/.test(input.value)) return parseInt(input.value, 10);
    var img = lineEl.querySelector('[data-current-qty]');
    var m = img && String(img.getAttribute('data-current-qty')).match(/\d+/);
    return m ? parseInt(m[0], 10) : NaN;
  }

  // Read-only: every write for one offer container plus Fly's total sale in cents (null when the
  // container has no total), or null (and nothing written) if anything about it is not what the
  // server figures describe.
  function plan(oc) {
    var pct = data.discountPct;
    var lines = oc.querySelectorAll(LINE);
    if (lines.length !== data.lines.length) return fail('line count ' + lines.length + ' != ' + data.lines.length);
    var writes = [];
    var seen = {};
    var full = 0;
    for (var i = 0; i < lines.length; i++) {
      var le = lines[i];
      var h = le.getAttribute('data-product-handle');
      var spec = h && byHandle.hasOwnProperty(h) ? byHandle[h] : null;
      if (!spec || seen[h]) return fail('unexpected line ' + h);
      seen[h] = true;
      var saleEl = le.querySelector(LINE_SALE);
      var wasEl = le.querySelector(LINE_WAS);
      if (!saleEl || !wasEl) return fail('line price nodes ' + h);
      var qty = lineQty(le);
      if (qty !== spec.qty) return fail('qty ' + h + ' ' + qty + ' != ' + spec.qty);
      var sale = money(saleEl.textContent);
      if (!sameShape(sale, ref)) return fail('line money format ' + h);
      var expected = (spec.unitCents * qty * (100 - pct)) / 100;
      if (Math.abs(expected - sale.cents) > 1) return fail('line sale ' + h + ' ' + sale.cents);
      writes.push([wasEl, spec.wasText]);
      full += spec.unitCents * qty;
    }
    if (full !== data.fullCents) return fail('full ' + full + ' != ' + data.fullCents);

    // Hidden by Fly's design on seven of the ten offers (only MINA Refill, MINA Complete and the
    // tumbler offer show it), but present, and kept up to date by Fly either way.
    var totalCents = null;
    var total = oc.querySelector(TOTAL);
    if (total) {
      var tSaleEl = total.querySelector(TOTAL_SALE);
      var tWasEl = total.querySelector(TOTAL_WAS);
      if (!tSaleEl || !tWasEl) return fail('total price nodes');
      var tSale = money(tSaleEl.textContent);
      if (!sameShape(tSale, ref) || Math.abs(tSale.cents - data.saleCents) > 1) return fail('total sale ' + (tSale && tSale.cents));
      if (nativeOn && !priceText(tSale.cents)) return fail('price format ' + tSale.cents);
      totalCents = tSale.cents;
      writes.push([tWasEl, data.fullText]);
      var pill = total.querySelector(PILL);
      var pillText = pill ? pill.textContent : '';
      if (pillText.trim()) {
        if (!PCT_RE.test(pillText)) return fail('pill text');
        writes.push([pill, pillText.replace(PCT_RE, pct + '%')]);
      }
    }
    return { writes: writes, total: totalCents };
  }

  // ------------------------------------------------------------------ one pass
  var shownSale = data.saleCents; // what the sale price elements should show
  var everMatched = false;
  var restored = false;
  var stopped = false;

  // totals: Fly's total for each widget applied in this pass, or null when none was (then the price
  // elements are only checked, never written).
  function nativePass(totals) {
    if (totals) {
      var t = totals[0];
      for (var i = 1; i < totals.length; i++) if (totals[i] !== t) t = null;
      shownSale = typeof t === 'number' ? t : data.saleCents;
    }
    var els = document.querySelectorAll(NATIVE);
    var bad = [];
    for (var k = 0; k < els.length; k++) {
      var el = els[k];
      var isSale = el.matches(NATIVE_SALE);
      var role = isSale ? 'sale' : 'was';
      var server = isSale ? data.saleCents : data.fullCents;
      var r = readNative(el);
      if (shows(r, isSale ? shownSale : data.fullCents)) continue;
      // Neither the server's figure nor this script's (which is at most 1 cent from it): someone
      // else wrote here.
      var foreign = !(r.label && r.m && sameShape(r.m, nativeRef) && Math.abs(r.m.cents - server) <= 1);
      if (!totals) {
        if (foreign && bad.indexOf(role) === -1) bad.push(role);
        continue;
      }
      writeNative(el, isSale ? data.saleLabel : data.wasLabel, isSale ? priceText(shownSale) : data.priceFullText);
      if (foreign) restored = true;
    }
    state.native = bad.length ? 'overwritten:' + bad.join(' ') : restored ? 'restored' : 'ok';
    state.sale = shownSale === data.saleCents ? 'card' : 'fly';
  }

  function pass() {
    if (stopped) return;
    var all = document.querySelectorAll(OFFER);
    var others = [];
    var matched = 0;
    var totals = [];
    state.status = 'waiting';
    for (var i = 0; i < all.length; i++) {
      var oc = all[i];
      var id = oc.getAttribute('data-offer-id');
      if (id !== data.offerId) {
        if (others.indexOf(id) === -1) others.push(id);
        continue;
      }
      matched++;
      var p = plan(oc);
      if (!p) continue;
      for (var k = 0; k < p.writes.length; k++) {
        if (p.writes[k][0].textContent !== p.writes[k][1]) p.writes[k][0].textContent = p.writes[k][1];
      }
      totals.push(p.total);
    }
    if (matched) everMatched = true;
    if (totals.length) state.status = 'applied';
    else if (!matched && others.length) fail('offer ' + others.join(' '));
    // (matched but not applied: plan() has set unchanged:<reason>; no widget at all: waiting)
    if (nativeOn) nativePass(totals.length ? totals : null);
    report();
    bind();
  }

  // ------------------------------------------------------------------ observers
  var nodeObs = null;
  var bodyObs = null;
  var bound = [];
  var seekTimer = null;

  function bind() {
    if (!nodeObs || stopped) return;
    var list = [];
    var all = document.querySelectorAll(OFFER);
    for (var i = 0; i < all.length; i++) {
      if (all[i].getAttribute('data-offer-id') !== data.offerId) continue;
      var w = all[i].closest(WRAPPER) || all[i];
      if (list.indexOf(w) === -1) list.push(w);
    }
    if (nativeOn) {
      var els = document.querySelectorAll(NATIVE);
      for (var j = 0; j < els.length; j++) list.push(els[j]);
    }
    var same = list.length === bound.length;
    for (var k = 0; same && k < list.length; k++) same = list[k] === bound[k];
    if (same) return;
    nodeObs.disconnect();
    for (k = 0; k < list.length; k++) nodeObs.observe(list[k], { childList: true, subtree: true, characterData: true });
    bound = list;
  }
  function stop() {
    stopped = true;
    if (nodeObs) nodeObs.disconnect();
    if (bodyObs) bodyObs.disconnect();
    if (seekTimer !== null) window.clearTimeout(seekTimer);
    seekTimer = null;
  }
  function safePass() {
    try {
      pass();
    } catch (e) {
      stop();
      fail('error ' + (e && e.message));
      try {
        report();
      } catch (ignore) {
        // nothing left to report on
      }
    }
  }
  var scheduled = false;
  function schedule() {
    if (scheduled || stopped) return;
    scheduled = true;
    Promise.resolve().then(function () {
      scheduled = false;
      safePass();
    });
  }
  function onBody(records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var a = added[j];
        if (a.nodeType === 1 && (a.matches(ADDED) || a.querySelector(ADDED))) {
          schedule();
          return;
        }
      }
    }
  }
  function giveUp() {
    seekTimer = null;
    if (everMatched || stopped) return;
    stop();
    if (state.status === 'waiting') fail('no widget');
    report();
  }
  function startClock() {
    if (stopped || everMatched || seekTimer !== null) return;
    seekTimer = window.setTimeout(giveUp, SEEK_MS);
  }

  if (typeof MutationObserver === 'function') {
    nodeObs = new MutationObserver(schedule);
    bodyObs = new MutationObserver(onBody);
    bodyObs.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }
  safePass();
  if (document.readyState === 'complete') startClock();
  else window.addEventListener('load', startClock);
})();
